import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;

  input {
    padding-right: 2.5rem;
  }

  button {
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%);

    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.5rem;

    background: none;
    border: none;

    color: #8fa8c7;
    font-size: 1.4rem;
    cursor: pointer;
  }
`;
